import { computed, inject } from '@angular/core';

import { toNotificationGroups } from '../presentation/notification-mapper';
import { NotificationResource } from '../resource/notification-resource';

import { useMarkAllNotificationsAsRead } from './use-mark-all-notifications-as-read';

export function useNotificationCenter() {
    const notificationResource = inject(NotificationResource);
    const markAll = useMarkAllNotificationsAsRead();
    const groups = computed(() => toNotificationGroups(notificationResource.items()));

    return {
        unread: computed(() => groups().unread),
        read: computed(() => groups().read),
        hasUnread: computed(() => groups().unread.length > 0),
        loading: notificationResource.loading,
        hasError: computed(() => notificationResource.error() !== undefined),
        markingAllAsRead: markAll.loading,
        markAllAsRead: markAll.execute,
        reload: () => notificationResource.reload(),
    };
}
